"use strict";
// import React from "react";
// // import ExampleVirtualTable from "example/virtual-table";
// // import ExampleVirtualTable from "./example/virtual-table";
// import ExampleTable from "./example";
// import { Column, DATA_TYPE, FILTER_CONDITION } from "./types";
// import { Button, Typography } from "antd";
// import dayjs from "dayjs";
// import { createRoot } from "react-dom/client";
// import { EyeOutlined } from "@ant-design/icons";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformFilters = exports.dynamicColumns = exports.useSchemaParser = exports.VirtualTable = exports.Table = void 0;
var export_1 = require("./export");
Object.defineProperty(exports, "Table", { enumerable: true, get: function () { return export_1.Table; } });
var virtual_table_1 = require("./virtual-table");
Object.defineProperty(exports, "VirtualTable", { enumerable: true, get: function () { return virtual_table_1.VirtualTable; } });
var openapi_schema_1 = require("./hooks/openapi-schema");
Object.defineProperty(exports, "useSchemaParser", { enumerable: true, get: function () { return openapi_schema_1.useSchemaParser; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "dynamicColumns", { enumerable: true, get: function () { return utils_1.dynamicColumns; } });
Object.defineProperty(exports, "transformFilters", { enumerable: true, get: function () { return utils_1.transformFilters; } });
//TODO: refactor and simplify code.
//# sourceMappingURL=index.js.map